import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  vacanciesList: [],
  vacanciesUsersList: [],
};

const slice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE citiesList
    getVacanciesListSuccess(state, action) {
      state.isLoading = false;
      state.vacanciesList = action.payload;
    },

    getVacanciesUsersListSuccess(state, action) {
      state.isLoading = false;
      state.vacanciesUsersList = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getVacanciesList() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('https://api.asystent.biz/api/vacancies');
        
        dispatch(slice.actions.getVacanciesListSuccess(response.data.vacancies));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}

export function getVacanciesUsersList(id) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('https://api.asystent.biz/api/vacancies/users/'+id);
        
        dispatch(slice.actions.getVacanciesUsersListSuccess(response.data.users));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}

export function getFilteredVacancy(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('https://api.asystent.biz/api/vacancies/filter',data);
        
        dispatch(slice.actions.getVacanciesListSuccess(response.data.vacancies));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}

export async function saveVacancy(data) {
    try {
      const response = await axios.post('https://api.asystent.biz/api/vacancies-new',data);
      
      return response.data
    } catch (error) {
      console.log(error);
    }
}

export async function updateVacancy(id,data) {
    try {
      const response = await axios.post('https://api.asystent.biz/api/vacancies-save/'+id,data);
      
      return response.data
    } catch (error) {
      console.log(error);
    }
}

export async function getVacancy(id,get="") {
    try {
      const response = await axios.get('https://api.asystent.biz/api/vacancies/'+id+get);
      
      return response.data
    } catch (error) {
      console.log(error);
    }
}

export async function dellVacancy(id) {
    try {
      const response = await axios.get('https://api.asystent.biz/api/vacancies-dell/'+id);
      
      return response.data
    } catch (error) {
      console.log(error);
    }
}